import React from "react";
import { useForm } from "react-hook-form";
import PopupWrapper from "../../../components/PopupWrapper";
import FormBox from "../../../components/FormBox/FormBox";
import { AddFeesSchema } from "../../../Utils/formOptions";

const AddFees = ({ showFees, setShowFees }) => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ ...AddFeesSchema });

  async function onSubmit(data) {}

  return (
    <PopupWrapper
      title={"Add Fees"}
      extraClass="width-800"
      Component={
        <div>
          <FormBox
            options={feesArr}
            register={register}
            watch={watch}
            setValue={setValue}
            errors={errors}
          />

          <div className="d-flex justify-content-end mt-5">
            <button
              type="button"
              className="btn btn-secondary me-3"
              onClick={() => setShowFees(false)}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary text-white"
              onClick={handleSubmit(onSubmit)}
            >
              Create
            </button>
          </div>
        </div>
      }
      toShow={showFees}
      closeEventHandler={() => {
        setShowFees(false);
      }}
    />
  );
};

export default AddFees;

const feesArr = [
  {
    title: "Fee",
    field: "Fee",
    type: "select",
    className: "col-12",
    options: [
      { label: "Recording Fee", value: "Recording Fee" },
      { label: "Payoff Demand Fee", value: "Payoff Demand Fee" },
      { label: "Prepayment Penalty", value: "Prepayment Penalty" },
      { label: "Document Preparation Fee", value: "Document Preparation Fee" },
    ],
  },
  {
    title: "Fee Amount",
    field: "FeeAmount",
    type: "text",
    className: "col-12",
  },
];
